/* One playback clock drives both the progress line and the next movement. */
(function () {
  'use strict';
  if (window.EarthleProductSlider) { window.EarthleProductSlider.boot(); return; }

  function init(sec) {
    if (sec.__psInit) return;
    var track = sec.querySelector('[data-ps-track]');
    var list = sec.querySelector('.e-ps-lijst');
    var slides = Array.prototype.slice.call(sec.querySelectorAll('[data-ps-slide]'));
    if (!track || slides.length < 2) return;
    sec.__psInit = true;
    var endSpace = document.createElement('li');
    var originalPadding = list ? list.style.paddingRight : '';
    endSpace.className = 'e-ps-end-space';
    endSpace.setAttribute('aria-hidden', 'true');
    endSpace.style.cssText = 'flex:0 0 0px;min-width:0;margin:0;padding:0;list-style:none;pointer-events:none';
    if (list) list.appendChild(endSpace);
    var prev = sec.querySelector('[data-ps-prev]');
    var next = sec.querySelector('[data-ps-next]');
    var toggle = sec.querySelector('[data-ps-toggle]');
    var interval = Number(sec.getAttribute('data-interval')) || 4000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var animation = null, current = -1, firstCycle = true, inView = false;
    var userPaused = false, touching = false;
    var moving = false, destroyed = false, pending = null, settleTimer = null;
    var removers = [], resizeObserver, measuredWidth = 0, measuredCard = 0;

    function listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      removers.push(function () { target.removeEventListener(name, handler, options); });
    }
    function maxLeft() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function position(index) { return slides[index].offsetLeft - slides[0].offsetLeft; }
    function nearestIndex() {
      var best = 0, distance = Infinity;
      slides.forEach(function (slide, index) {
        var candidate = Math.abs(position(index) - track.scrollLeft);
        if (candidate < distance) { distance = candidate; best = index; }
      });
      return best;
    }
    function fitEndSpace() {
      if (!list) return;
      var width = track.clientWidth;
      var card = slides[slides.length - 1].getBoundingClientRect().width;
      if (width === measuredWidth && Math.abs(card - measuredCard) < 0.5) return;
      var keep = current >= 0 ? current : nearestIndex();
      var start = slides[0].offsetLeft;
      var naturalWidth = start + position(slides.length - 1) + card;
      // Give the last card enough trailing space to reach the same left
      // alignment as every other card, instead of clamping midway through one.
      var tail = naturalWidth > width ? Math.max(0, width - start - card) : start;
      var gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
      list.style.paddingRight = '0px';
      // Overflowing flex rows do not consistently include end padding in
      // scrollWidth. A real, inert flex item provides reliable scroll space.
      endSpace.style.display = naturalWidth > width ? 'block' : 'none';
      endSpace.style.flexBasis = Math.max(0, Math.ceil(tail) - gap) + 'px';
      if (measuredWidth && !touching) {
        track.scrollTo({ left: Math.min(position(keep), maxLeft()), behavior: 'auto' });
      }
      measuredWidth = width;
      measuredCard = card;
    }
    function keyboardFocus() {
      var active = document.activeElement;
      return active && track.contains(active) && active.matches(':focus-visible');
    }
    function autoEnabled() {
      return sec.getAttribute('data-autoplay') !== 'false' && !reduced.matches &&
        typeof slides[0].querySelector('.e-ps-progress').animate === 'function' && maxLeft() > 2;
    }

    function geometry() {
      var r = track.getBoundingClientRect();
      var top = 0, bottom = window.innerHeight;
      var header = document.getElementById('HeaderWrapper');
      if (header) {
        var h = header.getBoundingClientRect();
        if (h.top <= 1 && h.bottom > 0 && h.bottom < bottom / 2) top = h.bottom;
      }
      var cookie = document.getElementById('shopify-pc__banner');
      if (cookie) {
        var c = cookie.getBoundingClientRect();
        if (c.width && c.height && c.bottom >= bottom - 1 && c.top > top &&
            getComputedStyle(cookie).visibility !== 'hidden') bottom = Math.min(bottom, c.top);
      }
      var left = Math.max(0, r.left), right = Math.min(window.innerWidth, r.right);
      var vertical = Math.max(0, Math.min(r.bottom, bottom) - Math.max(r.top, top));
      var horizontal = Math.max(0, right - left);
      // A tall card need not fit entirely on a short screen. Hysteresis avoids
      // repeatedly stopping and starting at the visibility boundary.
      var required = Math.min(r.height * (inView ? 0.35 : 0.5),
        Math.max(0, bottom - top) * (inView ? 0.3 : 0.45));
      var fractions = slides.map(function (slide) {
        var box = slide.getBoundingClientRect();
        return Math.max(0, Math.min(box.right, right) - Math.max(box.left, left)) /
          Math.max(1, box.width);
      });
      return { inView: required > 0 && vertical >= required && horizontal >=
        Math.min(slides[0].getBoundingClientRect().width / 2, window.innerWidth / 2),
        vertical: vertical, fractions: fractions };
    }
    function anchor(g) {
      var index = g.fractions.findIndex(function (fraction) { return fraction >= 0.85; });
      if (index < 0) index = g.fractions.indexOf(Math.max.apply(Math, g.fractions));
      return Math.max(0, index);
    }
    function pauseClock() {
      if (animation && animation.playState === 'running') animation.pause();
    }
    function cancelClock() {
      if (animation) { animation.onfinish = null; animation.cancel(); animation = null; }
      slides.forEach(function (slide) { slide.classList.remove('is-current'); });
    }
    function newCycle(g) {
      cancelClock();
      current = anchor(g);
      if (!autoEnabled()) return;
      var full = g.fractions.filter(function (fraction) { return fraction >= 0.85; }).length;
      var duration = firstCycle ? Math.min(interval, full > 1 ? 2500 : 3000) : interval;
      slides[current].classList.add('is-current');
      animation = slides[current].querySelector('.e-ps-progress').animate(
        [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
        { duration: duration, easing: 'linear', fill: 'forwards' });
      animation.pause();
      var cycle = animation;
      animation.onfinish = function () {
        if (animation !== cycle) return;
        inView = geometry().inView;
        if (canPlay()) advance(1, false);
      };
    }
    function canPlay() {
      var image = current >= 0 && slides[current].querySelector('img');
      return autoEnabled() && inView && !document.hidden && !userPaused &&
        !keyboardFocus() && !touching && !moving && (!image || image.complete);
    }
    function refresh() {
      if (destroyed) return;
      fitEndSpace();
      var g = geometry();
      inView = g.inView;
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-visible', g.vertical > 0 && g.fractions[index] > 0.02);
      });
      if (prev) prev.disabled = maxLeft() <= 2;
      if (next) next.disabled = maxLeft() <= 2;
      if (toggle) {
        toggle.hidden = !autoEnabled();
        var paused = userPaused || keyboardFocus();
        toggle.setAttribute('data-state', paused ? 'pauze' : 'speelt');
        toggle.setAttribute('aria-label', sec.getAttribute(paused ? 'data-hervat' : 'data-pauze'));
      }
      if (!autoEnabled()) { cancelClock(); return; }
      if (!moving && (current !== anchor(g) || !animation)) newCycle(g);
      if (!canPlay()) { pauseClock(); return; }
      if (animation.playState === 'finished') { advance(1, false); return; }
      if (animation.playState !== 'running') animation.play();
    }
    function queueRefresh() {
      if (pending !== null || destroyed) return;
      pending = requestAnimationFrame(function () { pending = null; refresh(); });
    }
    function settle() {
      clearTimeout(settleTimer);
      if (!moving || destroyed) return;
      var snapped = Math.min(position(nearestIndex()), maxLeft());
      if (!touching && Math.abs(track.scrollLeft - snapped) > 1) {
        track.scrollTo({ left: snapped, behavior: 'auto' });
      }
      moving = false;
      firstCycle = false;
      newCycle(geometry());
      refresh();
    }
    function trackScrolled() {
      moving = true;
      pauseClock();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 160);
      queueRefresh();
    }
    function advance(direction, keyboard) {
      if (moving || maxLeft() <= 2) return;
      var max = maxLeft(), x, wrap = false;
      var index = nearestIndex();
      if (direction > 0) {
        if (track.scrollLeft >= max - 4) { x = 0; wrap = true; }
        else {
          var target = Math.min(slides.length - 1, index + 1);
          x = Math.min(max, position(target));
        }
      } else if (track.scrollLeft <= 4) { x = max; wrap = true; }
      else {
        x = Math.max(0, position(Math.max(0, index - 1)));
      }
      if (Math.abs(x - track.scrollLeft) < 2) return;
      cancelClock();
      moving = true;
      firstCycle = false;
      // Rewinding the entire strip is instant; do not animate past nine cards.
      track.scrollTo({ left: x, behavior: reduced.matches || keyboard || wrap ? 'auto' : 'smooth' });
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 200);
    }

    sec.classList.add('is-js');
    if (prev) listen(prev, 'click', function (event) { advance(-1, event.detail === 0); });
    if (next) listen(next, 'click', function (event) { advance(1, event.detail === 0); });
    if (toggle) listen(toggle, 'click', function () { userPaused = !userPaused; refresh(); });
    listen(track, 'focusin', queueRefresh);
    listen(track, 'focusout', queueRefresh);
    listen(track, 'touchstart', function () { touching = true; pauseClock(); }, { passive: true });
    listen(track, 'touchend', function () { touching = false; queueRefresh(); }, { passive: true });
    listen(track, 'touchcancel', function () { touching = false; queueRefresh(); }, { passive: true });
    listen(track, 'scroll', trackScrolled, { passive: true });
    listen(track, 'scrollend', settle);
    // Vertical wheel/page scrolling only updates visibility; it never resets time.
    listen(window, 'scroll', queueRefresh, { passive: true });
    listen(window, 'resize', queueRefresh);
    listen(window, 'pageshow', function () { touching = false; queueRefresh(); });
    listen(window, 'pagehide', function () { touching = false; pauseClock(); });
    listen(document, 'visibilitychange', function () { touching = false; refresh(); });
    listen(document, 'visitorConsentCollected', queueRefresh);
    listen(track, 'load', queueRefresh, true);
    listen(track, 'error', queueRefresh, true);
    listen(reduced, 'change', refresh);
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(queueRefresh);
      resizeObserver.observe(track);
    }
    sec.__psDestroy = function () {
      destroyed = true;
      cancelClock();
      clearTimeout(settleTimer);
      if (pending !== null) cancelAnimationFrame(pending);
      if (resizeObserver) resizeObserver.disconnect();
      removers.forEach(function (remove) { remove(); });
      endSpace.remove();
      if (list) list.style.paddingRight = originalPadding;
      delete sec.__psInit;
      delete sec.__psDestroy;
    };
    refresh();
  }

  function boot() { document.querySelectorAll('[data-e-ps]').forEach(init); }
  window.EarthleProductSlider = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-e-ps]').forEach(function (sec) {
      if (sec.__psDestroy) sec.__psDestroy();
    });
  });
})();
